import { fetcher } from "helpers/fetcher";

import { TGetClientStakeholderReq, TGetClientStakeholderRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getClientStakeholder = async (
  params: TGetClientStakeholderReq
) => {
  return await fetcher<
    TGetClientStakeholderRes,
    TGetClientStakeholderReq["data"]
  >(ENDPOINT.CORPORATION.GET_CLIENT_STAKEHOLDER, {
    params: params.data,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.CORPORATION.GET_CLIENT_STAKEHOLDER.version,
      [API_HEADER.CORP_ID]: params?.idCorp,
    },
  });
};

export const queryGetClientStakeholder = async (
  params: TGetClientStakeholderReq
) => {
  return (await getClientStakeholder(params)).data;
};

queryGetClientStakeholder._key = (params: TGetClientStakeholderReq) => [
  ENDPOINT.CORPORATION.GET_CLIENT_STAKEHOLDER.url,
  params,
];
